import React from 'react';
import { Button, Col} from 'shards-react';

const SaveAndSubmit = ({ saveHandler, submitHandler, submitText, colclass, xs_, sm_, md_, showOnlySubmitColumn, submitButtonTheme }) => {
	const fontSize = 'initial';
	const columnClass = colclass || 'text-right p-0';
	const spanClass = 'align-middle ml-2';
	const _xs = xs_ || 5;
	const _sm = sm_ || 3;
	const _md = md_ || 2;

	return (
		<>
			{!showOnlySubmitColumn &&
				<Col xs={_xs} sm={_sm} md={_md} className={columnClass}>
					{saveHandler && (
						<Button outline pill theme='success' onClick={saveHandler}>
							<i className='fas fa-file-import align-middle' style={{ fontSize }} />
							<span className={spanClass}>Speichern</span>
						</Button>
					)}
				</Col>
			}						
			<Col xs={_xs} sm={_sm} md={_md} className={columnClass}>
				<Button pill theme={submitButtonTheme || 'success'} onClick={submitHandler}>
					<i className='fas fa-file-export align-middle' style={{ fontSize }} />
					<span className={spanClass}>{submitText}</span>
				</Button>				
			</Col>
		</>
	);
};

export default SaveAndSubmit;
